export const addressBookOverviewFrag = `
    id
    key
    total
    isGroup
    isCustom
    note
    serviceId
`;

export const addressBookContactFrag = `
    id
    externalId
    type
    organizationId
    email
    legalType
    titleBeforeName
    name
    surname
    titleAfterName
    image
    sex
    company
    data
    privateToUserId
`;

export const addressBookNoteFrag = `
    id
    note
    createdAt
`;

export const addressBookInformationFrag = `
    id
    type
    subtype
    editable
    info
`;

export const addressBookTagFrag = `
    id
    name
    note
    isGroup
    isCustom
    serviceId
`;

export const addressBookContactFullDetailFrag = `
    ${addressBookContactFrag}
    parentContact {
        ${addressBookContactFrag}
    }
    informations {
        ${addressBookInformationFrag}
    }
    tags {
        ${addressBookTagFrag}
    }
`;
